import { render } from "./AiFileBlock.vue?vue&type=template&id=77050e58&scoped=true"
import script from "./AiFileBlock.vue?vue&type=script&lang=js"
export * from "./AiFileBlock.vue?vue&type=script&lang=js"

import "./AiFileBlock.vue?vue&type=style&index=0&id=77050e58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77050e58"]])

export default __exports__